import { Component } from '@angular/core';
import { timer } from 'rxjs/observable/timer';
import { take, map } from 'rxjs/operators';

@Component({
  selector: 'wedding',
  templateUrl: './wedding.component.html',
  styleUrls: ['./wedding.component.css']
})
export class WeddingComponent {
  countDown;
  count;

  constructor() {
    this.count =  (Date.parse("07 29 2018 10:00:00") - Date.now()) / 1000;

      this.countDown = timer(0,1000).pipe(
         take(this.count),
         map(()=> --this.count)
      );
  }

  public getTimeRemaining(seconds: number) {
    var days = Math.floor(seconds / (3600*24));
    seconds  -= days*3600*24;
    var hrs   = Math.floor(seconds / 3600);
    seconds  -= hrs*3600;
    var mnts = Math.floor(seconds / 60);
    seconds  -= mnts*60;
    return days + " days, " + hrs + " hours, " + mnts + " minutes, " + Math.floor(seconds) + " seconds";
  }
}



// WEBPACK FOOTER //
// ./src/app/wedding/wedding.component.ts